import React, { useState, useEffect, useLayoutEffect } from 'react';
import useMedia from 'use-media';

import image_base from '../../resources/image/GrandeeHamanako2.jpg';
import { Link, useHistory } from "react-router-dom";
import image_complete from '../../resources/icons/complete.svg';
import image_button from '../../resources/icons/ico_reserve.svg';
import { GolfFooterContainer } from "./golfFooterContainer";
import { connect, useStore } from 'react-redux';
import common from '../../resources/js/common/common';
import { apiKeyCheck } from '../../const';
import '../../resources/css/soloReserve/golfSoloComplete.css'
import { useRtoaster } from '../../hooks/useRtoaster';

const GolfSoloCompleteContainer = (props) => {
    const {
        golfSoloTeetime,
        setGolfSoloTeetime,
        golfSoloSearchData,
        setGolfSoloSearchData,
        setSoloKaiinken,
        setSoloCourse,
        golfSoloReserveInfo,
        setGolfSoloReserveInfo,
        dispName
    } = props;

    const store = useStore();
    const history = useHistory();

    // rtoasterタグ生成
    const customParam = dispName == "cancel" ? 
        {
            "sisetucd": golfSoloReserveInfo.golfCourseId,
            "riyodat": golfSoloReserveInfo.playDate,
            "yoyakuno": golfSoloReserveInfo.reservationNo,
        }
        :
        {
            "sisetucd": golfSoloSearchData.golfCourseId,
            "riyodat": golfSoloSearchData.playDate,
            "keiyakuno": golfSoloSearchData.contractNo,
            "packcd": golfSoloSearchData.planId,
            "packnam": golfSoloSearchData.planName,
            "coursecd": golfSoloTeetime.courseId,
            "startjikan": golfSoloTeetime.startTime,
        }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }


    useEffect(() => {
        // common.versionCheck();
        setGolfSoloTeetime({});
        setGolfSoloSearchData({});
        setSoloKaiinken([]);
        setSoloCourse([]);
        setGolfSoloReserveInfo({});
    }, []);

    return (
        <div className='soloComplete_contaner'>
            <div className='soloComplete_base'>
                <div className='soloComplete_complete'></div>
                <p className='soloComplete_completeTitle'>{props.completeTitle}</p>
                <p className='soloComplete_completeText'>ご利用いただき誠にありがとうございます。<br />{props.completeBody}<br className='soloComplete_deleteBr' />{props.completeBody2}</p>
                <Link className='soloComplete_link' to={"/reserve/golf/soloSearch"} >ゴルフ一人予約TOPに戻る</Link>
            </div>
            <div className='soloComplete_footer'>
                <GolfFooterContainer />
            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        golfSoloSearchData: state.golfSoloSearchData,
        golfSoloTeetime: state.golfSoloTeetime,
        golfSoloReserveInfo: state.golfSoloReserveInfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setGolfSoloSearchData: (item) => {
            dispatch({ type: "GOLF_SOLO_SEARCH_DATA", payload: { golfSoloSearchData: item } })
        },
        setGolfSoloTeetime: (item) => {
            dispatch({ type: "GOLF_SOLO_TEETIME", payload: { golfSoloTeetime: item } })
        },
        setSoloCourse: (item) => {
            dispatch({ type: "SOLO_COURSE", payload: { soloCourse: item } })
        },
        setSoloKaiinken: (item) => {
            dispatch({ type: "SOLO_KAIINKEN", payload: { soloKaiinken: item } })
        },
        setGolfSoloReserveInfo: (item) => {
            dispatch({ type: "GOLF_SOLO_RESERVE_INFO", payload: { golfSoloReserveInfo: item } })
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GolfSoloCompleteContainer);